/* eslint-disable max-len */
import get from 'lodash/get';
import intersection from 'lodash/intersection';
import localCache from '@/utils/cache';
import { getAutoMediaType, FILE_TYPE, safeParseJSON } from '../utils/util';
import { PAGE_STATUS_MAP } from '@/utils/constant';

const autoMediaOutPut = 'videoPics';
// 为了不损失信息收集三期的富文本处理。。自己转成html。
function convertJsonToHtml(data) {
    if (data.length === 0) {return '';}
    let html = '';
    data.forEach(pageKey => {
        // eslint-disable-next-line max-len
        html += `<div style="font-size: 15px;color: #222; margin-bottom: 8px; font-weight:500; line-height: 21px;" class="reason-area">${pageKey.label}</div>`;
        html += '<ol class="reason-area-ol">';
        for (const item of pageKey.markList) {
            for (const outputItem of item.outputList) {
                // eslint-disable-next-line max-len
                html += `<li style="font-size: 15px; font-weight: 400;color: #666; list-style: decimal; line-height: 21px;">${outputItem.label}: ${item.mark}</li>`;
            }
        }
        html += '</ol>';
    });
    return html;
}
// eslint-disable-next-line complexity
export function saveInitData(state, { response, serverDraft = null }) {
    const { gray = {
        fieldReview: 1, // 字段级驳回灰度
    }, status } = state;
    const { biz, data, pages, config = {}, prefillInfos = {}, commonInfo = {}, mediaInfos = [], formNotice: formNoticeResponse = {} } = response || {};
    const { needProcess } = biz.config;
    const { noticeAutoOpen } = config;
    const userCurrentInfo = get(data, '0');
    const nextPageKey = get(userCurrentInfo, 'nextPage');
    // 字段级驳回灰度中 && 需要审核 && 信息收集状态为3
    const matchGrayRules = gray && gray.fieldReview && needProcess && status === 3;
    const noticeJson = get(userCurrentInfo, 'data.noticeJson');
    const noticeJsonParse = noticeJson ? JSON.parse(noticeJson) : [];
    // 刚神死活不做这个逻辑
    const filterNoticeArray = noticeJsonParse.filter(v => v.markList.length !== 0) || [];
    // 创建映射关系
    const stepPages = biz.pages;
    const pageStepMap = new Map(stepPages.map((v, index) => [v.label, index + 1]));
    // isChanged 为了处理驳回字段是否展示的
    const initNoticeArray = filterNoticeArray.map(v => {
        const { markList } = v;
        markList.forEach(item => {
            item.outputList.forEach(nope => {
                nope.isChanged = false;
            });
        });
        return v;
    });

    const sortArray = initNoticeArray.sort((a, b) => {
        const pageA = pageStepMap.get(a.label);
        const pageB = pageStepMap.get(b.label);
        return pageA - pageB;
    });

    let announcementRemark = '';
    const formNotice = safeParseJSON(formNoticeResponse); // 表单型公告
    try {
        // 富文本公告 如果formNotice有值，announcementRemark就不需要赋值了
        if (!formNotice) {
            announcementRemark = matchGrayRules
                ? convertJsonToHtml(sortArray)
                : get(userCurrentInfo, 'data.notice');
        }
    } catch (error) {
        console.error(error, 'An error occurred while: get(userCurrentInfo, notice) ');
    }
    let userData = {};
    try {
        const userDataString = get(userCurrentInfo, 'data.detail');
        userData = userDataString ? JSON.parse(userDataString) : {};
    } catch (error) {
        console.log(error);
    }
    const stashEffectiveDuration = (get(config, 'stashEffectiveDuration') || 0) * 60 * 1000;
    // 只有 INVALID(0) 状态（第一次填写、尚未提交）才读取本地草稿
    const cacheData = status === PAGE_STATUS_MAP.INVALID
        ? localCache.get(`cacheKey_${state.currentBizKey}_${state.from || 'default'}`)
        : {};
    // 【草稿互通】服务端草稿优先，本地 localStorage 草稿兜底
    // 优先级：serverDraft (跨渠道Redis草稿) > cacheData (本地localStorage草稿)
    const effectiveDraft = serverDraft && Object.keys(serverDraft).length > 0
        ? serverDraft
        : cacheData;
    const newUserData = biz && biz.biz === 'child-tip-refund-game-v3' ? {
        ...effectiveDraft,
        ...userData,
    } : {
        ...userData,
        ...effectiveDraft,
    };
    const preInfo = { ...prefillInfos, ...commonInfo };
    const hasPreMediaInfo = mediaInfos ? mediaInfos.some(item => item.fileKey) : false;
    /**
     * 1.有缓存，说明打开修改过，不自动带入
     * 2.没有缓存，根据createTime > 0 判断是否提交过，提交过 => 不自动带入 没有提交过 && 没有值 => 自动带入
     */
    const hasSubmit = get(userCurrentInfo, 'data.createTime');
    const isAutoFillInfo = Boolean(!Object.keys(effectiveDraft).length && !hasSubmit && (preInfo || hasPreMediaInfo)); // 没有缓存 && 没提交过 && 预填字段有值
    // 预填信息
    if (isAutoFillInfo) {
        const prefillKeys = Object.keys(preInfo);
        Object.keys(pages).forEach(pageKey => {
            try {
                const config = JSON.parse(pages[pageKey].config);
                const children = get(config, 'config.props.children') || [];
                const childrenKeys = children.map(item => item.output);
                const intersectionKeys = intersection(prefillKeys, childrenKeys);
                if (intersectionKeys.length) {
                    if (!newUserData[pageKey]) {
                        newUserData[pageKey] = {};
                    }
                    intersectionKeys.forEach(key => {
                        if (!newUserData[pageKey][key]) {
                            newUserData[pageKey][key] = preInfo[key];
                        }
                    });
                }
                // 自动带入媒体信息
                if (childrenKeys.includes(autoMediaOutPut) && hasPreMediaInfo) {
                    if (!newUserData[pageKey]) {
                        newUserData[pageKey] = {};
                    }
                    // 自动带入有格式判断 判断是图片or视频
                    const autoMediaItem = children.find(item => item.output === autoMediaOutPut);
                    const { accept = '', max } = autoMediaItem.props || {};
                    let fileList = [];
                    if (!newUserData[pageKey][autoMediaOutPut]) {
                        const fileType = getAutoMediaType(accept);
                        switch (fileType) {
                            case FILE_TYPE.IMAGE:
                            case FILE_TYPE.VIDEO:
                                fileList = mediaInfos
                                    .filter(item => item.type === fileType)
                                    .map(file => file.fileKey);
                                break;
                            default:
                                fileList = mediaInfos.map(item => item.fileKey);
                                break;
                        }
                        // 自动带入数据不超过上传文件的最大 0 表示无限制
                        if (max && max < fileList.length) {
                            newUserData[pageKey][autoMediaOutPut] = fileList.slice(-Number(max));
                            return;
                        }
                        newUserData[pageKey][autoMediaOutPut] = fileList;
                    }
                }
            } catch (error) {
                console.log(error);
            }
        });
    }
    // 驳回字段
    Object.assign(state, {
        bizInfo: biz,
        pageInfo: pages,
        nextPageKey: nextPageKey,
        userData: newUserData,
        noticeAutoOpen: noticeAutoOpen, // 公告是否自动打开
        errorData: sortArray || [], // 字段级错误信息
        stashEffectiveDuration,
        announcementRemark,
        formNotice: formNotice,
    });
}

export function saveCurrentPageData(state, { pageKey, data }) {
    state.userData = {
        ...state.userData,
        [pageKey]: data,
    };
}

export function saveNextPageKey(state, { pageKey }) {
    state.nextPageKey = pageKey;
}

export function saveExtraInfo(state, extraInfo) {
    state.extraInfo = {
        ...state.extraInfo,
        ...extraInfo,
    };

}

export function saveOtherQuery(state, otherQuery) {
    state.otherQuery = otherQuery;
}

export function saveTicket(state, ticket) {
    state.ticket = {
        ...state.ticket,
        ...ticket,
    };
}

export function saveMyServiceBizKey(state, key) {
    state.myServiceBizKey = key;
}

export function changeCheckPhone(state, checkPhone) {
    state.checkPhone = checkPhone;
}

export function updateErrorData(state, newErrorData) {
    state.errorData = newErrorData;
}